/* import __COLOCATED_TEMPLATE__ from './sh-input.hbs'; */
import { action, computed } from '@ember/object';
import { reads } from '@ember/object/computed';

import MaterializeInputField from './sh-input-field';

export default MaterializeInputField.extend({
  type: 'text',
  defaultMessage: null,
  successMessage: null,
  dataError: computed('data-error', 'error', function () {
    return this.get('error') ? this.get('error') : this.get('data-error');
  }),
  inputClasses: computed('validate', 'isValid', 'isInvalid', 'isLoading', function () {
    const classes = [];

    if (this.get('validate')) {
      classes.push('validate');
    }

    if (this.get('isValid')) {
      classes.push('valid');
    }

    if (this.get('isInvalid')) {
      classes.push('invalid');
    }

    if (this.get('isLoading')) {
      classes.push('loading');
    }

    return classes.join(' ');
  }),
  "data-default": reads("defaultMessage"),
  "data-error": null,
  "data-success": computed('defaultMessage', 'successMessage', function () {
      return this.get('successMessage') ? this.get('successMessage') : this.get('defaultMessage');
    }
  ),
  sendBlurNotice: action(function() {
    this.onblur?.();
  }),
  sendFocusNotice: action(function() {
    this.onfocus?.();
  }),
  isInvalid: computed('error', function () {
    return !!this.get('error');
  }),
  labelSuffix: computed('required', 'readonly', function () {
    return this.get('required') && !this.get('readonly') ? '*' : null;
  }),
});
